import React, { useState } from 'react'
import {
  Button,
  Box,
  Snackbar,
  CircularProgress,
  Typography,
} from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import PurchaseOrderForm from './purchaseOrderForm'
import {
  IPurchaseOrder,
  IPurchaseOrderItem,
  PurchaseOrder,
  PurchaseOrderItem,
} from 'interfaces/IPurchaseOrder'
import API from '@aws-amplify/api'

export default function CreatePurchaseOrder() {
  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] =
    React.useState(false)
  const [isFailureSnackbarOpen, setIsFailureSnackbarOpen] =
    React.useState(false)

  const [purchaseOrderData, setPurchaseOrderData] = useState<IPurchaseOrder>(
    new PurchaseOrder({ poDate: new Date(), status: 'PENDING' })
  )
  const [purchaseOrderItems, setPurchaseOrderItems] = useState<
    IPurchaseOrderItem[]
  >([new PurchaseOrderItem({})])
  const [isLoading, setIsLoading] = React.useState<any>(false)
  const [alertMessage, setAlertMessage] = React.useState('')

  const handleSnackbarClose = (): void => {
    setIsFailureSnackbarOpen(false)
    setIsSuccessSnackbarOpen(false)
  }

  const handlePurchaseOrderFieldChange = (value: any, key: string): void => {
    setPurchaseOrderData({ ...purchaseOrderData, [key]: value })
  }
  const handlePurchaseOrderItemFieldChange = (
    value: any,
    key: string,
    changedIdx: number
  ): void => {
    setPurchaseOrderItems((prevState) =>
      prevState.map((purchaseOrderItem, idx) => {
        if (changedIdx === idx)
          return {
            ...purchaseOrderItem,
            [key]: value,
          }
        return purchaseOrderItem
      })
    )
  }

  const handleDeletePurchaseOrderItem = (idxToDelete: number) => {
    setPurchaseOrderItems(
      purchaseOrderItems.filter((purchaseOrderItem, idx) => idx !== idxToDelete)
    )
  }

  const handleAddPurchaseOrderItem = () => {
    setPurchaseOrderItems(purchaseOrderItems.concat(new PurchaseOrderItem({})))
  }

  const handleSavePurchaseOrder = async () => {
    try {
      const mappedItems = purchaseOrderItems.map((purchaseOrderItem) => {
        const totalPrice =
          (purchaseOrderItem.quantityPurchased ?? 0) *
            (purchaseOrderItem.unitPrice ?? 0) -
          (purchaseOrderItem.discount ?? 0)
        return { ...purchaseOrderItem, totalPrice }
      })
      setIsLoading(true)
      await API.post('products', `/purchaseOrders/createPurchaseOrder`, {
        body: { ...purchaseOrderData, items: mappedItems },
      })
      window.location.reload()
      setAlertMessage('Berhasil membuat PO.')
      setIsSuccessSnackbarOpen(true)
    } catch (error) {
      setAlertMessage('Gagal membuat PO.')
      setIsFailureSnackbarOpen(true)
    }
    setIsLoading(false)
  }

  const isPurchaseOrderValid = () => {
    const requiredPoFields: Array<keyof IPurchaseOrder> = [
      'supplier',
      'poNumber',
      'poDate',
      'type',
    ]
    const requiredPoItemFields: Array<keyof IPurchaseOrderItem> = [
      'itemId',
      'itemName',
      'unitPrice',
      'taxType',
      'quantityPurchased',
    ]
    const isPoValid = requiredPoFields.every((field) =>
      Boolean(purchaseOrderData[field])
    )
    const isAllItemValid = requiredPoItemFields.every((field) =>
      purchaseOrderItems.every((purchaseOrderItem) =>
        Boolean(purchaseOrderItem[field])
      )
    )

    return isPoValid && isAllItemValid
  }

  return (
    <Box>
      <Box p={2}>
        <PurchaseOrderForm
          purchaseOrderData={purchaseOrderData}
          purchaseOrderItems={purchaseOrderItems}
          handlePurchaseOrderFieldChange={handlePurchaseOrderFieldChange}
          handlePurchaseOrderItemFieldChange={
            handlePurchaseOrderItemFieldChange
          }
          handleAddPurchaseOrderItem={handleAddPurchaseOrderItem}
          handleDeletePurchaseOrderItem={handleDeletePurchaseOrderItem}
        />
        {isLoading && (
          <Box p={3}>
            <CircularProgress />
          </Box>
        )}
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSavePurchaseOrder}
            disabled={!isPurchaseOrderValid()}
          >
            Save
          </Button>
          {!isPurchaseOrderValid() && (
            <Box ml={2} display="inline">
              <Typography display="inline">
                Pastikan semua data sudah terisi untuk membuat PO.
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      <Snackbar
        open={isSuccessSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="success" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={isFailureSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="error" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  )
}
